module.exports = __webpack_public_path__ + "static/media/minimize.27246a10.svg";